import { SetInitialData } from './initial-data.actions';
import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { InitialDataStateModel, LabelValue, Language, UserData } from 'src/app/model';

@State<InitialDataStateModel>({
  name: 'initialData',
  defaults: {
    applicationsToRoleMap: null,
    applicationList: [],
    environmentList: { main: [] },
    userData: { email: '', isAdmin: false },
    languageList: [],
  },
})
@Injectable()
export class InitialDataState {
  @Selector()
  static initialData(state: InitialDataStateModel): InitialDataStateModel {
    return state;
  }

  @Selector()
  static applicationList(state: InitialDataStateModel): Array<LabelValue> {
    return state.applicationList;
  }

  @Selector()
  static environmentList(state: InitialDataStateModel): Array<LabelValue> {
    return state.environmentList.main;
  }

  @Selector()
  static languageList(state: InitialDataStateModel): Array<Language> {
    return state.languageList;
  }

  @Selector()
  static userData(state: InitialDataStateModel): UserData {
    return state.userData;
  }

  @Action(SetInitialData)
  setInitialData({ getState, patchState }: StateContext<InitialDataStateModel>, { payload }: { payload: InitialDataStateModel }): void {
    patchState({
      ...getState(),
      ...payload,
    });
  }
}
